import { createSseStats, decodeSseData, } from './wire.js';
function subscription(close, stats) {
    let closed = false;
    const dispose = () => {
        if (closed)
            return;
        closed = true;
        close();
    };
    return Object.assign(dispose, { stats });
}
/**
 * Subscribe to the app's SSE stream. With `enabled: false` (mock mode) it opens nothing and
 * returns a no-op disposer. Unknown event types are counted and passed to `onUnknown`.
 */
export function subscribeAppEvents(url, handlers, options) {
    const stats = createSseStats();
    if (!options.enabled)
        return subscription(() => { }, stats);
    const Source = globalThis.EventSource;
    if (Source === undefined)
        throw new Error('EventSource is not available');
    const source = new Source(url);
    const onMessage = (message) => {
        let decoded;
        try {
            decoded = decodeSseData(String(message.data), {
                id: message.lastEventId === '' ? undefined : message.lastEventId,
                stats,
            });
        }
        catch (error) {
            // decodeSseData throws only SseFrameError.
            handlers.onMalformed?.(error);
            return;
        }
        if (decoded.kind === 'app') {
            const handler = handlers[decoded.event.type];
            handler?.(decoded.event, decoded.id);
        }
        else if (decoded.kind === 'unknown') {
            handlers.onUnknown?.(decoded);
        }
        else {
            stats.unknown += 1;
            stats.unknownByType[decoded.event.type] = (stats.unknownByType[decoded.event.type] ?? 0) + 1;
            handlers.onUnknown?.({
                kind: 'unknown',
                unknown: true,
                type: decoded.event.type,
                data: decoded.event.data,
            });
        }
    };
    const onOpen = () => handlers.onOpen?.();
    const onError = (event) => handlers.onError?.(event);
    source.addEventListener('message', onMessage);
    source.addEventListener('open', onOpen);
    source.addEventListener('error', onError);
    return subscription(() => {
        source.removeEventListener('message', onMessage);
        source.removeEventListener('open', onOpen);
        source.removeEventListener('error', onError);
        source.close();
    }, stats);
}
//# sourceMappingURL=subscribe.js.map